export default __webpack_public_path__ + "static/media/display1.d0e36ef3.png";